/* RESPONSIBLE TEAM: team-ml */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentSalesTestTestRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentSalesTestTestRoute, {
  overrideRenderTemplate: false,
});
